import { useMutation } from '@tanstack/react-query';
import { addCampaignRewardImage, createCampaignReward, sendCampaignInvite } from './fetcher';

export const useSendCampaignInvite = (options) => {
	return useMutation({
		mutationFn: sendCampaignInvite,
		...options
	});
};

export const useCreateCampaignReward = (options) => {
	return useMutation({
		mutationFn: createCampaignReward,
		...options
	});
};

export const useAddCampaignRewardImage = (options) => {
	return useMutation({
		mutationFn: addCampaignRewardImage,
		...options
	});
};
